import { ModelSortVariant } from "@/types/defs/modelSortVariant";
import { Artist } from "@/types/types";

// Base ordering of the artist grid before the free-voices/tutorial/filter passes. Returns a new array; the catalogue itself is never mutated.
export const sortArtistsBySortVariant = ({
  artists,
  sortVariant,
  popularityByArtistId,
}: {
  artists: Artist[];
  sortVariant: ModelSortVariant;
  popularityByArtistId: Record<string, number> | null;
}): Artist[] => {
  if (sortVariant === "recent") {
    // Artist id is a monotonic add-counter (verified against the git add-history), so descending id reproduces chronological order.
    return [...artists].sort(
      (artistA, artistB) => Number(artistB.id) - Number(artistA.id)
    );
  }

  if (sortVariant === "popular") {
    // Highest popularity score first. Artists with no recorded paid usage (absent from the map, or before the data loads) score 0 and sort last.
    return [...artists].sort(
      (artistA, artistB) =>
        (popularityByArtistId?.[artistB.id] ?? 0) -
        (popularityByArtistId?.[artistA.id] ?? 0)
    );
  }

  return [
    ...artists.filter((artist) => artist.meta.new),
    ...artists.filter((artist) => !artist.meta.new),
  ];
};
